import axios from 'axios';
import { pb } from './pocketbase';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

// Export des formations avec ruptures et nombre d'élèves - Téléchargement direct en Excel
export const exportFormationsRuptures = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/api/export/formations-ruptures`, {
            headers: {
                'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'Authorization': `Bearer ${JSON.parse(localStorage.getItem('pocketbase_auth')).token}`
            },
            responseType: 'blob' // Important pour télécharger en tant que blob
        });
        
        // Extraire le nom de fichier depuis les en-têtes de réponse
        const contentDisposition = response.headers['content-disposition'];
        let filename = 'export-formations-ruptures.xlsx';
        if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename="(.+)"/);
            if (filenameMatch) {
                filename = filenameMatch[1];
            }
        }
        
        // Créer et télécharger le fichier Excel
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        // Nettoyer l'URL créée
        URL.revokeObjectURL(url);
        
        return { success: true, filename };
    } catch (error) {
        console.error("Error exporting formations ruptures data:", error);
        throw error;
    }
};

// Export des top formations avec qualification_title, nombre de promotions et nombre d'élèves - Téléchargement direct en Excel
export const exportTopFormations = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/api/export/top-formations`, {
            headers: {
                'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'Authorization': `Bearer ${JSON.parse(localStorage.getItem('pocketbase_auth')).token}`
            },
            responseType: 'blob' // Important pour télécharger en tant que blob
        });
        
        // Extraire le nom de fichier depuis les en-têtes de réponse
        const contentDisposition = response.headers['content-disposition'];
        let filename = 'export-top-formations.xlsx';
        if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename="(.+)"/);
            if (filenameMatch) {
                filename = filenameMatch[1];
            }
        }
        
        // Créer et télécharger le fichier Excel
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        // Nettoyer l'URL créée
        URL.revokeObjectURL(url);
        
        return { success: true, filename };
    } catch (error) {
        console.error("Error exporting top formations data:", error);
        throw error;
    }
};